import { Component, OnInit } from '@angular/core';
import { SystemCapabilityEnum } from 'src/app/models/data/systemCapability';
import { ApiService } from 'src/app/services/api.services';
import { SystemCapabilityService } from 'src/app/services/system-capabilities/system-capability.service';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { AppTabNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { MatTabGroup, MatTab, MatTabContent } from '@angular/material/tabs';
import { QueryStringTabGroupDirective } from '../../../directives/query-string-tab-group.directive';
import { AllDevicesComponent } from '../main/all-devices/all-devices.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';
import { DeviceGroupsComponent } from '../main/device-groups/device-groups.component';
import { DeviceLookupComponent } from '../device-lookup/device-lookup.component';
import { MigrateDevicesTabComponent } from '../migrate-devices-tab/migrate-devices-tab.component';

@Component({
	selector: 'app-device-main-tab',
	templateUrl: './device-main-tab.component.html',
	styleUrls: ['./device-main-tab.component.scss'],
	imports: [
		AppTabNavigationHeaderComponent,
		MatTabGroup,
		QueryStringTabGroupDirective,
		MatTab,
		MatTabContent,
		AllDevicesComponent,
		BreadcrumbLabelDirective,
		DeviceGroupsComponent,
		DeviceLookupComponent,
		MigrateDevicesTabComponent,
	],
})
export class DeviceMainTabComponent implements OnInit {
	isOracle = false;
	hasDeviceManagementCapability = false;
	isSentriKeyAccessUser = false;
	activeCompanyId?: string;

	breadcrumbLabel = $localize`:@@deviceMainTab-breadcrumbLabel:Devices`;

	allDevicesBreadcrumbLabel = this.breadcrumbLabel;
	deviceGroupsBreadcrumbLabel = this.breadcrumbLabel;
	deviceLookupBreadcrumbLabel = this.breadcrumbLabel;
	addDeviceBreadcrumbLabel = this.breadcrumbLabel;

	// Do NOT set this variable to true! Only used for unit tests.
	isUnitTesting = false;

	constructor(
		private readonly apiService: ApiService,
		private readonly scService: SystemCapabilityService,
		private readonly userProfileService: UserProfileService
	) {
		this.isOracle = this.scService.isOracle;
		this.hasDeviceManagementCapability = this.scService.has(
			SystemCapabilityEnum.deviceManagement
		);
	}

	async ngOnInit() {
		await this.fetchUserInfo();
	}

	async fetchUserInfo() {
		const [profile, sentrilockId] = await Promise.all([
			this.userProfileService.getUserProfile(),
			this.apiService.getSentrilockCompanyId(),
		]);
		this.activeCompanyId = profile.activeRoleDetails?.company?.id;
		this.isSentriKeyAccessUser = this.activeCompanyId === sentrilockId;
	}

	getApiService() {
		return this.apiService;
	}

	getUserProfileService() {
		return this.apiService;
	}
}
